import { ArgsType, Field, Float } from '@nestjs/graphql'

@ArgsType()
export class UpdateTaxArgs {
  @Field(t => Float)
  taxRate!: number

  @Field(t => Float, { nullable: true })
  extraTaxRate?: number

  @Field()
  taxCountryCode!: string

  @Field()
  postalCode!: string

  @Field()
  taxCode!: string

  @Field({ nullable: true })
  ipAddress?: string

  @Field()
  taxName!: string

  @Field({ nullable: true })
  extraTaxName?: string
}
